export default "__VITE_ASSET__Rb23E9Di__"